import styled from 'styled-components';

interface ExpiredPageProps {
  message?: React.ReactNode;
}

const ExpiredPage = ({ message }: ExpiredPageProps) => {
  return (
    <ExpiredTemplate>
      <CenterWrap>
        <ImageWrap>
          <img src={process.env.PUBLIC_URL + '/images/img_intro.svg'} alt="intro" />
        </ImageWrap>
        <ImageWrap>
          <img src={process.env.PUBLIC_URL + '/images/img_intro_title.svg'} alt="title" />
        </ImageWrap>
        <IntroText>
          {message ?? (
            <>
              주변에 해양사고가 발생했습니다.
              <br />
              수색구조가 완료되었습니다.
            </>
          )}
        </IntroText>
      </CenterWrap>
    </ExpiredTemplate>
  );
};

const ExpiredTemplate = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #000d3a 48.5%, #cdd2e0 100%);
`;
const CenterWrap = styled.div`
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -30%);
  align-items: center;
  text-align: center;
`;
const ImageWrap = styled.div`
  text-align: center;
  margin-bottom: 10px;
`;
const IntroText = styled.h1`
  width: 280px;
  margin-top: 60px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 35px;
  text-align: center;
  align-items: center;
`;

export default ExpiredPage;
